require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./study-study-comic-relief-dynamics-gift-aid.json") })
        }
      }, "path---study-study-comic-relief-dynamics-gift-aid");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---study-study-comic-relief-dynamics-gift-aid!./.cache/json/study-study-comic-relief-dynamics-gift-aid.json
// module id = 932
// module chunks = 231608221292675